import styled from "styled-components";
import { makeStyles } from "@material-ui/core/styles";
import Background from "../../assets/login/background.jpg";
import BackgroundSGP from "../../assets/login/background_sgp.jpg";
import {lgDown, smDown} from "../../ui/common";
import SwipeableViews from "react-swipeable-views";

export const StyledTopBackground = styled.div`
  height: 460px;
  width: 100%;
  background-image: ${({country}) => country === 'SGP' ? 'url(' + BackgroundSGP +')' : 'url(' + Background +')'};
  background-size: cover;
  background-position: 50%;
  display: flex;
  flex-direction: column;
  align-items: center;
  ${lgDown`
    height: 245px;
  `}
  ${smDown`
    height: 165px;
  `}
`;

export const HeaderWrapper = styled.div`
  margin: 0 auto;
  width: 100%;
  max-width: 1110px;
  height: 100%;
  position: relative;
`;

export const StyledMiddleBackground = styled.div`
  background-color: #f6f8fa;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 64px;
  ${lgDown`
    padding: 0 0 40px 24px;
  `}
  ${smDown`
    padding: 60px 0 40px 16px;
  `}
`;

export const StyledBottomBackground = styled(StyledMiddleBackground)`
  background-color: white;
  height: 803px;
  ${lgDown`
    height: 100%;
    min-height: 611px;
    padding-bottom: 40px;
  `}
  ${smDown`
    padding: 0 0 40px 16px;
    min-height: 520px;
  `}
`;

export const StyledInfoBox = styled.div`
  height: 182px;
  width: 1111px;
  border-radius: 20px;
  background-color: rgba(255, 255, 255, 0.8);
  box-shadow: 0 0 60px 0 rgba(0, 0, 0, 0.06);
  margin: 146px 0 164px;
  display: flex;
  justify-content: space-between;
  ${lgDown`
    width: 646px;
    height: 120px;  
    margin-top: 25px;
    margin-left: 24px;
  `}
  ${smDown`
    margin: 16px 16px 30px;
    height: 100%;
    width: auto;
    background-color: rgba(255, 255, 255, 1);
    display: block;
    padding: 16px;
  `}
`;

export const StyledInfoWrapper = styled.div`
  width: 60%;
  ${lgDown`
    width: 45%;
  `}
  ${smDown`
    width: 100%;
`}
`;

export const StyledInfoTitle = styled.div`
  color: #003da5;
  font-family: Stag;
  font-size: 32px;
  font-weight: 500;
  line-height: 40px;
  padding-top: 48px;
  padding-left: 30px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  ${lgDown`
    font-size: 24px;
    padding-top: 24px;
    padding-left: 24px;
  `}
  ${smDown`
    font-size: 20px;
    line-height: 24px;
    padding: 0;
  `}
`;

export const StyledInfoSubTitle = styled.div`
  color: #0a1f44;
  font-family: Inter;
  font-size: 18px;
  line-height: 28px;
  padding-left: 30px;
  ${lgDown`
    padding-left: 24px;
  `}
  ${smDown`
    font-size: 16px;
    line-height: 20px;
    padding: 8px 0 16px;
  `}
`;

export const QnectButtonWraper = styled.div`
  padding-top: 54px;
  padding-right: 30px;
  flex-shrink:0;
  ${lgDown`
    padding-top: 25px;
    padding-right: 24px;
  `}
  ${smDown`
    padding: 0;
  `}
`;

export const StyledTitle = styled.div`
  color: #0a1f44;
  font-family: Stag;
  font-size: 24px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 28px;
  padding-top: 64px;
  ${lgDown`
    padding-top: 30px;
  `}
`;

export const StyledTitleRow = styled(StyledTitle)`
  display: flex;
  justify-content: space-between;
  ${lgDown`
    display: block;
  `}
`;

export const StyledItemWrapper = styled.div`
  display: flex;
`;

export const StyledPendingSwipeable = styled(SwipeableViews)`
  @media (max-width: 1279px) {
    padding: 0 800px 0 0;
  }
  @media (max-width: 1150px) {
    padding: 0 700px 0 0;
  }
  @media (max-width: 1080px) {
    padding: 0 600px 0 0;
  }
  @media (max-width: 959px) {
    padding: 0 500px 0 0;
  }
  @media (max-width: 849px) {
    padding: 0 400px 0 0;
  }
  @media (max-width: 759px) {
    padding: 0 300px 0 0;
  }
  @media (max-width: 650px) {
    padding: 0 200px 0 0;
  }
  @media (max-width: 550px) {
    padding: 0 100px 0 0;
  }
  @media (max-width: 450px) {
    padding: 0 100px 0 0;
  }
  @media (max-width: 450px) {
    padding: 0 20px 0 0;
  }
`;

export const StyledSwipeable = styled(StyledPendingSwipeable)`
  @media (max-width: 1279px) {
    padding: 0 700px 0 0;
  }
  @media (max-width: 1080px) {
    padding: 0 600px 0 0;
  }
  @media (max-width: 959px) {
    padding: 0 500px 0 0;
  }
  @media (max-width: 849px) {
    padding: 0 400px 0 0;
  }
  @media (max-width: 759px) {
    padding: 0 300px 0 0;
  }
  @media (max-width: 650px) {
    padding: 0 200px 0 0;
  }
  @media (max-width: 550px) {
    padding: 0 100px 0 0;
  }
  @media (max-width: 450px) {
    padding: 0 50px 0 0;
  }
  @media (max-width: 390px) {
    padding: 0 20px 0 0;
  }
`;

export const StyledNewsSwipeable = styled(SwipeableViews)`
  @media (max-width: 1279px) {
    padding: 0 700px 0 0;
  }
  @media (max-width: 1080px) {
    padding: 0 600px 0 0;
  }
  @media (max-width: 959px) {
    padding: 0 550px 0 0;
  }
  @media (max-width: 859px) {
    padding: 0 450px 0 0;
  }
  @media (max-width: 759px) {
    padding: 0 350px 0 0;
  }
  @media (max-width: 650px) {
    padding: 0 250px 0 0;
  }
  @media (max-width: 450px) {
    padding: 0 150px 0 0;
  }
`;

export const StyledLocatePolicyWrapper = styled(StyledItemWrapper)`
  cursor: pointer;
`;

export const StyledWhatsNewsTitle = styled(StyledTitle)`
  padding-top: 64px;
  ${lgDown`
    padding-top: 30px;
  `}
`;

export const StyledSectionWrapper = styled.div`
  width: 1110px;
  ${lgDown`
    width: 100%;
  `}
`;

export const StyledMessage = styled.div`
    margin-top: 38px;
    font-family: Inter-Regular;
    font-size: 16px;
    color: #0A1F44;
    @media (max-width:767.95px){
      margin-right: 16px;
    }
`;

const usePortfolioStyles = makeStyles(theme => ({

  portfolio_container: {
    width: '1100px',
    height: 'fit-content',
    margin: '0 auto',
    [theme.breakpoints.between("1024", "1120")]: {
      width: '95%',
    },
    '& .makeStyles-policy_card-7:last-child' : {
      marginBottom: '50px',
    },
    '& .action_buttons_container' : {
      '& div' : {
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      },
      '& button' : {
        margin: '0 10px',
        borderRadius: '27px',
        height: '52px',
      },
    },
    '& .imageDiv' : {},
    '& .ToolTipDiv' : { },
    '& .messageDiv' : {
      fontFamily: 'Inter Medium, Inter-Medium, Inter, sans-serif',
      marginTop: '30px',
      color: "#00C457"
    },
    '& .errorMessageDiv' : {
      fontFamily: 'Inter Medium, Inter-Medium, Inter, sans-serif',
      marginTop: '30px',
      color: "#d54040"
    },
    position: "relative",
    [theme.breakpoints.up("sm")]: {},
    [theme.breakpoints.between("sm", "md")]: {},
    [theme.breakpoints.up("lg")]: {}
  },


  standard_topHeader: {
    marginTop: '30px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    justifyContent: 'flex-end',
    alignItems: 'center',
    gap: '30px',
    '& a' : {
      fontFamily: 'Inter, Inter-Regular, sans-serif',
      color: '#003DA5',
    },
  },
  logo_container: {
    flexBasis: '50%'
  },
  nav_container: {
    flexBasis: '50%',
    display: 'flex',
    '& a:hover, & a:focus' : {
      textDecoration: 'none'
    },
  },

  welcome_text_container: {
    width: '100%',
    marginTop: '80px',
    '& h1' : {
      fontFamily: 'Stag, sans-serif',
      color: '#0A1F44',
      fontSize: '36px',
      letterSpacing: '1px',
      fontWeight: '400'
    }
  },

  portfolio_title: {
    width: '100%',
    marginTop: '30px',
    '& h2' : {
      fontFamily: 'Stag, sans-serif',
      color: '#0A1F44',
      fontSize: '32px',
      letterSpacing: '1px',
      fontWeight: '400'
    }
  },

  policy_card: {
    width: '100%',
    borderRadius: '10px',
    boxShadow: '2px 2px 8px rgba(20,40,75,0.2)',
    padding: '30px 40px',
    border: '1px solid #E1E4E8',
    display: 'flex',
    flexWrap: 'wrap',
    marginBottom: '30px',
    '& div' : {
      flexBasis: '100%',
      display: 'flex'
    },
    '& div[class*="subsidiary_plan_cards"]::-webkit-scrollbar' : {
      width: '5px',
    },
    '& div[class*="subsidiary_plan_cards"]::-webkit-scrollbar-track' : {
      background: '#E1E4E8',
    },
    '& div[class*="subsidiary_plan_cards"]::-webkit-scrollbar-thumb' : {
      background: '#b4b9c2',
    },
    '& div[class*="subsidiary_plan_cards"]::-webkit-scrollbar-thumb:hover' : {
      background: '#8A94A6',
    }
  },

  policy_details: {
    paddingBottom: '30px',
    borderBottom: '1px solid #E1E4E8'
  },

  policy_number_details: {
    '& img' : {},
    '& div' : {
      marginLeft: '25px',
      flexDirection: 'column',
      '& span:first-child' : {
        marginBottom: '3px'
      },
      '& span:nth-child(2)' : {
        color: '#003DA5',
        fontFamily: 'Inter, Inter Regular, Inter-Regular, sans-serif',
        fontSize: '20px',
        lineHeight: '28px',
        fontWeight: '500'
      },
    },
  },

  policy_titles: {
    color: '#4D515B',
    fontFamily: 'Inter, Inter-Regular, Inter Regular, sans-serif',
    fontSize: '16px',
    lineHeight: '24px'
  },

  policy_date_status: {
    // display: 'none !important'
    display: 'block !important',
    '& .policy_status' : {
      fontFamily: 'Inter, Inter Regular, Inter-Regular, sans-serf',
      borderWidth: '1px',
      borderStyle: 'solid',
      fontSize: '12px',
      padding: '6px 10px',
      flexBasis: 'auto !important',
      borderRadius: '6px',
      marginTop: '5px',
      width: 'fit-content'
    },
    '& .status_active' : {
      borderColor: '#00C457',
      color: '#00C457',
      backgroundColor: 'rgba(0,196,86,0.008)',
    },
    '& .status_expiring_soon' : {
      borderColor: '#D43900',
      color: '#D43900',
      backgroundColor: 'rgba(212, 57, 0, 0.008)'
    },
    '& .status_inactive' : {
      borderColor: '#0A1F44',
      color: '#0A1F44',
      backgroundColor: 'rgba(241, 242, 244, 0.008)',
    }
  },
   policy_date: {
    color: '#000000',
    fontFamily: 'Inter, Inter Regular, Inter-Regular, sans-serif',
    fontSize: '20px',
    lineHeight: '28px',
    fontWeight: '500'
  },

  policy_premium: {
    // display: 'none !important'
    display: 'block !important'
  },
  policy_premium_price: {
    color: '#009AE4',
    fontFamily: 'Inter, Inter Regular, Inter-Regular, sans-serif',
    fontSize: '20px',
    lineHeight: '28px',
    fontWeight: '700'
  },
  policy_sub_premium_price: {
    color: '#4D515B',
    fontFamily: 'Inter, Inter Regular, Inter-Regular, sans-serif',
    fontSize: '16px',
    lineHeight: '24px',
    fontWeight: '400',
    marginTop: '4px'
  },

  subsidiary_plan_cards: {
    marginTop: '30px',
    display: 'flex',
    gap: '30px',
    flexWrap: 'wrap',
    justifyContent: 'flex-start',
    maxHeight: '194px',
    overflowY: 'auto',
  },

  subsidiary_card: {
    borderRadius: '10px',
    border: '1px solid #E1E4E8',
    padding: '25px',
    display: 'block !important',
    flexWrap: 'wrap',
    flexBasis: '31% !important',
    '& h2' : {
      fontFamily: 'Inter Semibold, Inter-Semibold, Inter Semi-bold, sans-serif',
      fontSize: '16px',
      lineHeight: '24px',
      color: '#0A1F44',
      margin: '0 0 25px 0',
      flexBasis: '100%'
    },
    '& h3' : {
      fontFamily: 'Inter Regular, Inter-Regular, Inter, sans-serif',
      fontSize: '12px',
      lineHeight: '21px',
      color: '#4D515B',
      margin: '0',
      flexBasis: '100%'
    },
    '& div' : {
      display: 'flex',
      flexBasis: '100%',
      flexWrap: 'wrap',
      '& a' : {
        flexBasis: '33%',
        fontFamily: 'Inter Medium, Inter-Medium, Inter, sans-serif',
        fontSize: '18px',
        lineHeight: '21px',
        color: '#003DA5',
        margin: '15px 0 0 0',
      },
      '& a:hover' : {
        textDecoration: 'none'
      }
    },
    '& a': {
      cursor: 'pointer'
    }
  }

}));

export default usePortfolioStyles;